import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Address, toAddress } from '@k2/common/entities-state/types';
import { HhgAddress, HhgDestinationAddress, HhgOriginAddress, HhgOriginStorageAddress } from '@k2/staff/content/clients/client/assignment/hhg/overview/addresses/list/addresses-list.component';
import * as _ from 'lodash';

@Component({
  selector: 'formatted-address',
  templateUrl: 'formatted-address.component.html',
  styleUrls: ['formatted-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FormattedAddressComponent {

  private _address: Address;
  get address(): Address {
    return this._address;
  }

  @Input() set address(value: Address | HhgAddress | HhgOriginAddress | HhgOriginStorageAddress | HhgDestinationAddress) {
    if (!_.isEmpty(value)) {
      if (!('address1' in value)) {
        this._address = toAddress(value);
      } else {
        this._address = value;
      }
    }
  }

  @Input() reducedFormat?: boolean = false;
  @Input() isAssignmentEncrypted: boolean = true;
}
